import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { AuthService, EmployeeService, LayoutService } from '../../../@core/utils';
import { map, takeUntil, filter } from 'rxjs/operators';
import { Subject, interval, Subscription } from 'rxjs';
import { UserProfileService } from '../../../@core/utils/user-profile.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private authSub: Subscription;
  private userProfileSub: Subscription;
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  seller: any;
  _isAuth$ = interval(3 * 60 * 1000)
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [{ icon: 'id-card-alt', title: 'แก้ไขข้อมูลส่วนตัว', pack: 'fa', link: 'pages/user-profile/edit' }, { icon: 'sign-out-alt', title: 'ออกจากระบบ', pack: 'fa' }];

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private authService: AuthService,
    private employeeService: EmployeeService,
    private userProfileService: UserProfileService
  ) {
  }

  ngOnInit() {
    this.userProfileSub = this.userProfileService.currentUserProfile.subscribe(res1 => {
      this.employeeService.getSellerAccount().subscribe((res: any) => {
        this.seller = res.data;
      })
    });
    this.currentTheme = this.themeService.currentTheme;

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'my-context-menu'),
        map(({ item: { title } }) => title),
      )
      .subscribe(title => title == 'ออกจากระบบ' ? this.logout() : '')
    // init employee
    this.employeeService.getSellerAccount().subscribe((res: any) => {
      this.seller = res.data;
    })
    this.authenticate()
  }
  async logout() {
    let out = await this.userProfileService.logoutSeller().toPromise();
    this.authService.logout();
  }

  ngOnDestroy() {
    if (this.userProfileSub) {
      this.userProfileSub.unsubscribe();
    }
    if (this.authSub) {
      this.authSub.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
  authenticate() {
    // check authenticate
    this.authSub = this._isAuth$.subscribe(() => {
      this.employeeService.getSellerAccount().subscribe((res: any) => {
        this.seller = res.data;
      });
    });

  }


}
